import React, { useRef, useState } from "react";
import { Card } from "semantic-ui-react";
import ScrollableWrapper from "../../wrappers/ScrollableWrapper";

const CardList = () => {

  const [currentKey, setCurrentKey] = useState(null);

  // Sample data
  const cards = Array.from({ length: 100 }, (_, i) => ({
    id: `card-${i + 1}`,
    content: `Card ${i + 1}`,
  }));

  const handleCardClick = (id) => {
    sessionStorage.setItem("selectedCard", id); // Save clicked card ID to sessionStorage
  };

  return (
    <div style={{ height: "100%" }} >
      <button onClick={() => setCurrentKey("card-75")}>Scroll to Card 75</button>
      <ScrollableWrapper storageKey="selectedCard" _currentKey={currentKey}>
        {cards.map((card) => (
          <Card
            fluid
            key={card.id}
            id={card.id}
            onClick={() => handleCardClick(card.id)} // Save card key on click
            className={card.id === sessionStorage.getItem("selectedCard") ? "itemSelected" : ""}
          >
            <Card.Content>{card.content}</Card.Content>
          </Card>
        ))}
      </ScrollableWrapper>
    </div >
  );
};

export default CardList;
